import React from "react";
import "./dropdowns.scss";

import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { RootState } from "src/redux/reducers";

import { ReactComponent as CampaignDataIcon } from "src/images/campaign-data.svg";
import { ReactComponent as CreatorIcon } from "src/images/menu-icons/creator-database.svg";
import { ReactComponent as AudienceDataIcon } from "src/images/audience-data.svg";
import { ReactComponent as AudienceOverlapIcon } from "src/images/audience-overlap.svg";
import { ReactComponent as InfoGreyIcon } from "src/images/info-grey.svg";
import {
  Dropdown,
  DropdownMenu,
  DropdownMenuItem,
} from "../../../components/Dropdown/Dropdown";

import { Button } from "../../../components/Button/Button";

export function CampaignDataDropdown() {
  const history = useHistory();
  const {
    mainReducer: { activeWorkspaceUuid, identity },
    projectReducer: { projectBasicData },
  } = useSelector((state: RootState) => state);

  if (!projectBasicData?.permissions?.project.includes("download_report")) {
    return null;
  }

  const openDetailsOnTab = (activeTab: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("activeTab", activeTab);
    if (activeTab !== "project-summary") {
      searchParams.set("scrollToTabs", "true");
    }
    const search = searchParams.toString();
    history.push({
      pathname: `/workspace/${activeWorkspaceUuid}/projects/${projectBasicData.projectId}/details`,
      search,
    });
  };

  return (
    <Dropdown className="campaign-data-dropdown" toRight>
      {(isOpen, setIsOpen: React.Dispatch<React.SetStateAction<boolean>>) => (
        <>
          <Button
            variant="white"
            size="thin"
            onClick={() => setIsOpen((v) => !v)}
          >
            <CampaignDataIcon />
            <IDHFormattedMessage
              id="ws_campaign_data"
              defaultMessage="Campaign Data"
            />
          </Button>

          <DropdownMenu isOpen={isOpen}>
            <DropdownMenuItem
              onClick={() => openDetailsOnTab("project-summary")}
              data-qa="show-details-button"
            >
              <InfoGreyIcon />
              <IDHFormattedMessage
                id="ws_show_details"
                defaultMessage="Show details"
              />
            </DropdownMenuItem>

            <DropdownMenuItem
              onClick={() => openDetailsOnTab("creators-insights")}
              data-qa="creator-insights-button"
            >
              <CreatorIcon />
              <IDHFormattedMessage
                id="ws_creator_insights"
                defaultMessage="Creator insights"
              />
            </DropdownMenuItem>

            <DropdownMenuItem
              onClick={() => openDetailsOnTab("audience-data")}
              data-qa="audience-data-button"
            >
              <AudienceDataIcon />
              <IDHFormattedMessage
                id="ws_audience_data"
                defaultMessage="Audience data"
              />
            </DropdownMenuItem>

            {identity?.isAudienceOverlapEnabled && (
              <DropdownMenuItem
                onClick={() => openDetailsOnTab("audience-overlap")}
                data-qa="audience-overlap-button"
              >
                <AudienceOverlapIcon />
                <IDHFormattedMessage
                  id="ws_audience_overlap"
                  defaultMessage="Audience overlap"
                />
              </DropdownMenuItem>
            )}
          </DropdownMenu>
        </>
      )}
    </Dropdown>
  );
}
